import React, { memo, forwardRef } from "react";
const SvgRatio = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M16 13a2 2 0 100-4 2 2 0 000 4zm0 10a2 2 0 100-4 2 2 0 000 4z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgRatio.displayName = "SvgRatio";
const MemoForwardRef = memo(SvgRatio);
export default MemoForwardRef;
